import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import styles from "./Kanban.module.css";

const OUTCOME_LABEL = {
  confirmed: { t: "подтверждена", c: "var(--green)" },
  rejected: { t: "отклонена", c: "var(--red)" },
  inconclusive: { t: "неясно", c: "var(--amber)" },
};

const PRODUCT_LABEL = {
  rublox: "Рублокс",
  minecraftia: "Майнкрафтия",
  maska: "Маська",
  ecosystem: "Экосистема",
};

export default function KanbanCard({ card, onClick, onMetrics }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({ id: card.id });
  const style = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.4 : 1,
  };
  const outcome = card.outcome ? OUTCOME_LABEL[card.outcome] : null;
  // Кнопки «Инфо»/«Метрики» — на карточках в колонке «Замеряем»
  const showButtons = card.column_key === "measuring";

  // Кнопки не должны запускать drag и «клик по карточке»
  const stop = (e) => e.stopPropagation();

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={styles.card}
      {...listeners}
      {...attributes}
      onClick={(e) => {
        // клик без перетаскивания
        if (!isDragging) onClick();
      }}
    >
      <div className={styles.cardTitle}>{card.title}</div>
      <div className={styles.cardMeta}>
        {card.ice_score != null && (
          <span style={{
            background: "var(--accent-soft)", color: "var(--accent)",
            padding: "1px 7px", borderRadius: 10, fontWeight: 600,
          }}>
            {card.ice_score}
          </span>
        )}
        {card.product && <span>{PRODUCT_LABEL[card.product] || card.product}</span>}
        {card.owner && <span>{card.owner}</span>}
        {card.week_iso && <span>{card.week_iso}</span>}
        {outcome && <span style={{ color: outcome.c }}>{outcome.t}</span>}
      </div>
      {showButtons && (
        <div className={styles.cardBtns} onPointerDown={stop} onMouseDown={stop}>
          <button
            className={styles.cardBtn}
            onClick={(e) => { stop(e); onClick(); }}
          >
            Инфо
          </button>
          <button
            className={`${styles.cardBtn} ${styles.cardBtnAccent}`}
            onClick={(e) => { stop(e); onMetrics && onMetrics(card); }}
          >
            Метрики
          </button>
        </div>
      )}
    </div>
  );
}
